import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../index';

import './index.sass'

export const LinkButton = ({to, children, ...props}) => {
    return <Button Tag={Link} to={to} {...props}>
        {children}
    </Button>
}

